import styled from "styled-components";

export const StyledCheckboxList = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: -10px;
    color: black;
`